/* eslint-disabled */

export default class LocationExtend {


  constructor (object?: any) {
  }

}
